import AWS from 'aws-sdk';
import devEnv from './aws-exports-dev';
import prodEnv from './aws-exports';

const API_KEY = 'AKIA3NB2P2S7NWX2FOQG';
const ACCESS_KEY = 'eH5fXCXLBIYMwV3+D+QR0udVOapFaNJmlwCzuKf8';
const isDev = process.env.REACT_APP_ENVIRONMENT === "development";
AWS.config.update({
  region: isDev ? devEnv['aws_project_region'] : prodEnv["aws_project_region"],
  credentials: {
    accessKeyId: API_KEY,
    secretAccessKey: ACCESS_KEY,
  },
});

const docClient = new AWS.DynamoDB.DocumentClient();

export { docClient };
